import { MenuItem } from 'primeng/api';

export class LoadPortalMenus {
  static readonly type = '[Menu] Load portal menus from API';
}

export class SetPortalMenuBar {
  static readonly type = '[Menu] Set bar items';
  constructor(public items: MenuItem[]) {}
}
